import { render, staticRenderFns } from "./ConfirmarReserva.vue?vue&type=template&id=0b364cc6&scoped=true&"
import script from "./ConfirmarReserva.vue?vue&type=script&lang=js&"
export * from "./ConfirmarReserva.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarReserva.vue?vue&type=style&index=0&id=0b364cc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b364cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VImg,VRow})
